  document.addEventListener("DOMContentLoaded", () => {
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach((item, index) => {
      const header = item.querySelector(".faq-header");
      const body = item.querySelector(".faq-body");
      const arrow = item.querySelector(".faq-arrow");

      if (index === 0) {
        item.classList.add("active");
        body.style.maxHeight = body.scrollHeight + "px";
        arrow.classList.add("rotated");
      }

      header.addEventListener("click", () => {
        const isOpen = item.classList.contains("active");

        faqItems.forEach(el => {
          el.classList.remove("active");
          el.querySelector(".faq-body").style.maxHeight = null;
          el.querySelector(".faq-arrow").classList.remove("rotated");
        });

        if (!isOpen) {
          item.classList.add("active");
          body.style.maxHeight = body.scrollHeight + "px";
          arrow.classList.add("rotated");
        }
      });
    });
  });